var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon24PxBackpackOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17041 6.33838H14.8315C15.5822 6.33838 16.3021 6.63659 16.833 7.16744C17.3639 7.69827 17.6621 8.41824 17.6621 9.16895V21.1989H6.33984V9.16895C6.33984 8.41824 6.63806 7.69827 7.1689 7.16744C7.69973 6.63659 8.4197 6.33838 9.17041 6.33838Z",
    stroke: "CurrentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33898 21.1995H2.80078V15.5383C2.80078 15.163 2.94989 14.803 3.21531 14.5376C3.48072 14.2722 3.8407 14.123 4.21606 14.123H6.33898",
    stroke: "CurrentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6621 14.123H19.785C20.1604 14.123 20.5204 14.2722 20.7858 14.5376C21.0511 14.803 21.2003 15.163 21.2003 15.5383V21.1995H17.6621",
    stroke: "CurrentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33984 12.7075H17.6621",
    stroke: "CurrentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.292V14.1226",
    stroke: "CurrentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16992 6.33827V5.63062C9.16992 4.87991 9.46814 4.15994 9.99898 3.62911C10.5298 3.09827 11.2498 2.80005 12.0005 2.80005C12.7512 2.80005 13.4712 3.09827 14.002 3.62911C14.5328 4.15994 14.831 4.87991 14.831 5.63062V6.33827",
    stroke: "CurrentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24PxBackpackOutline);
export default __webpack_public_path__ + "static/media/icon_24px_backpack_outline.d64362b2270d5536e174ecfd8ec9b47b.svg";
export { ForwardRef as ReactComponent };